var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 8.5H12.4C12.5591 8.5 12.7117 8.56321 12.8243 8.67573C12.9368 8.78826 13 8.94087 13 9.1V15.9C13 16.0591 12.9368 16.2117 12.8243 16.3243C12.7117 16.4368 12.5591 16.5 12.4 16.5H1.6C1.44087 16.5 1.28826 16.4368 1.17574 16.3243C1.06321 16.2117 1 16.0591 1 15.9V9.1C1 8.94087 1.06321 8.78826 1.17574 8.67573C1.28826 8.56321 1.44087 8.5 1.6 8.5H3M11 8.5V4.5C11 3.167 10.2 0.5 7 0.5C3.8 0.5 3 3.167 3 4.5V8.5M11 8.5H3",
    stroke: "#29292E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.2919a98575b479d448562d5dd0ed7f7b.svg";
export { ForwardRef as ReactComponent };